const isWeb = true;
import { getSystemType } from '@nibfe/mkt-env-api';
import { SystemType } from '@nibfe/mkt-env-api/src/libs/enum';
let libs;
if (true)
    libs = require('@nibfe/mkt-libs');
/**
 * 判断给定的 URL 是否为 H5 页面的 URL
 * @see https://sky.sankuai.com/docs/nibfe/platform-common-api-repository/
 */
export const isH5URL = (url) => {
    return Boolean(url && url.indexOf('http') === 0);
};
export const convertLinkToAppMiddleOpenLink = (url) => {
    return `https://m.dianping.com/awp/hfe/block-page/call-native/meituan.html?url=${encodeURIComponent(url)}`;
};
export function appendParams(url, params) {
    // 分离 hash 部分
    const [baseUrlWithQuery, hash] = url.split('#');
    const [baseUrl, queryString] = baseUrlWithQuery.split('?');
    // 解析现有查询参数
    const queryParams = queryString ? queryString.split('&') : [];
    const existingParams = {};
    queryParams.forEach(pair => {
        const [key, value] = pair.split('=');
        existingParams[decodeURIComponent(key)] = decodeURIComponent(value);
    });
    // 合并新参数
    const combinedParams = {
        ...existingParams,
        ...params
    };
    // 构建新的查询字符串
    const newQueryString = Object.entries(combinedParams).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
    // 拼接最终的 URL
    return `${baseUrl}?${newQueryString}${hash ? `#${hash}` : ''}`;
}
export function getUTM() {
    try {
        const systemType = getSystemType();
        const isAndroid = systemType === SystemType.android;
        const isIOS = systemType === SystemType.ios;
        const isInHarmony = systemType === SystemType.harmony;
        let utm_medium = isIOS ? 'iphone' : isAndroid ? 'android' : isInHarmony ? 'HarmonyOS' : 'iphone';
        if (isWeb && libs) {
            const { env } = libs;
            if (env.miniProgram.isMiniProgram()) {
                utm_medium = 'WEIXINPROGRAM';
            }
            else {
                // 在Web环境下，优先使用已经判断的鸿蒙结果，否则使用env判断
                if (!isInHarmony) {
                    // eslint-disable-next-line no-nested-ternary
                    utm_medium = env.system.isAndroid() ? 'android' : env.system.isIphone() ? 'iphone' : utm_medium;
                }
            }
        }
        return utm_medium;
    }
    catch (e) {
        return 'iphone';
    }
}
